export default "__VITE_ASSET__DMDuRYNT__"